import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["input", "isReadOnly", "isDisabled", "placeholder", "isRequired", "label", "helperText", "description", "validateOnMount", "meta", "FormItemProps"];
import React from 'react';
import PropTypes from 'prop-types';
import Input from "antd/es/input/index.js";
import useFieldApi from "@data-driven-forms/react-form-renderer/use-field-api";
import FormGroup from '../form-group';

var TextField = function TextField(props) {
  var _useFieldApi = useFieldApi(props),
      input = _useFieldApi.input,
      isReadOnly = _useFieldApi.isReadOnly,
      isDisabled = _useFieldApi.isDisabled,
      placeholder = _useFieldApi.placeholder,
      isRequired = _useFieldApi.isRequired,
      label = _useFieldApi.label,
      helperText = _useFieldApi.helperText,
      description = _useFieldApi.description,
      validateOnMount = _useFieldApi.validateOnMount,
      meta = _useFieldApi.meta,
      FormItemProps = _useFieldApi.FormItemProps,
      rest = _objectWithoutProperties(_useFieldApi, _excluded);

  return /*#__PURE__*/React.createElement(FormGroup, {
    label: label,
    meta: meta,
    validateOnMount: validateOnMount,
    helperText: helperText,
    description: description,
    FormItemProps: FormItemProps,
    isRequired: isRequired
  }, /*#__PURE__*/React.createElement(Input, _extends({}, input, {
    defaultValue: input.value ? input.value : undefined,
    disabled: isDisabled,
    readOnly: isReadOnly,
    placeholder: placeholder
  }, rest)));
};

TextField.propTypes = {
  isReadOnly: PropTypes.bool,
  isDisabled: PropTypes.bool,
  placeholder: PropTypes.node,
  isRequired: PropTypes.bool,
  label: PropTypes.node,
  helperText: PropTypes.node,
  validateOnMount: PropTypes.bool,
  description: PropTypes.node,
  FormItemProps: PropTypes.object
};
export default TextField;